import React, { useState, useEffect } from 'react';
import './FilterPanel.css';
import Modal from 'react-modal';
import { FILTER_CATEGORIES } from './filterCategories.js';


function FilterPanel({ onApplyFilter, selectedHashtag }) {
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [selectedProducers, setSelectedProducers] = useState([]);
  const [selectedVideoTypes, setSelectedVideoTypes] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [showAllFilters, setShowAllFilters] = useState(false);

  const MAX_VISIBLE_FILTERS = 3;

  const initialSelectedFilters = FILTER_CATEGORIES.reduce(
    (acc, category) => ({
      ...acc,
      [category.key]: [],
    }),
    {hashtag: []}
  );
  
  const [selectedFilters, setSelectedFilters] = useState(initialSelectedFilters);
   
  useEffect(() => {
    console.log("selected filter: ", selectedFilters);
  }, [selectedFilters]);

  useEffect(() => {
    // Remove duplicates
    const uniqueHashtags = [...new Set(selectedHashtag)];

    setSelectedFilters(prevFilters => ({
        ...prevFilters,
        hashtag: selectedHashtag
    }));
  }, [selectedHashtag]);
    

  const applyFilter = () => {
    onApplyFilter(selectedFilters);
    setShowFilters(false);
    console.log("passed selected filters: ", selectedFilters);
  };
  

  const resetFilters = () => {
    setSelectedFilters(initialSelectedFilters);    
  };  

  // This function will handle the removal of a filter value
  const removeFilterValue = (categoryKey, value) => {
    setSelectedFilters((prev) => {
      const updatedFilters = {
        ...prev,
        [categoryKey]: prev[categoryKey].filter((item) => item !== value),
      };
      onApplyFilter(updatedFilters);  // Add this line to update results.
      return updatedFilters;
    });
  };
  

  const displaySelectedFilters = () => {
    const filtersToDisplay = [...FILTER_CATEGORIES, { key: 'hashtag', label: 'Hashtag' }];
    const allSelectedFilters = [];

    filtersToDisplay.forEach(category => {
        const selectedValues = selectedFilters[category.key].filter(Boolean);
        selectedValues.forEach(value => {
            allSelectedFilters.push({ category: category.key, value });
        });
    });

    const visibleFilters = showAllFilters ? allSelectedFilters : allSelectedFilters.slice(0, MAX_VISIBLE_FILTERS);
    const hiddenCount = allSelectedFilters.length - MAX_VISIBLE_FILTERS;

    return (
        <>
            {visibleFilters.map(item => (
                <span className="filter-badge" key={`${item.category}-${item.value}`}>
                    {item.category === 'hashtag' ? `#${item.value}` : item.value}
                    <button className="remove-filter-btn" onClick={() => removeFilterValue(item.category, item.value)}>X</button>
                </span>
            ))}
            {!showAllFilters && hiddenCount > 0 && 
                <span className="filter-badge-more" onClick={() => setShowAllFilters(true)}>+{hiddenCount} more</span>
            }
        </>
    );
  };

  
  const handleFilterChange = (category, value, checked) => {
    setSelectedFilters((prevFilters) => {
      const updatedCategoryFilters = checked
        ? [...prevFilters[category], value]
        : prevFilters[category].filter((item) => item !== value);
  
      return { ...prevFilters, [category]: updatedCategoryFilters };
    });
  };  
  

  Modal.setAppElement('#root');

  console.log("Rendering filters:", selectedFilters);


  return (
    <div className='filter-panel'>
      <button onClick={() => {console.log('Filters button clicked'); setShowFilters(!showFilters)}}>Filters</button>
      <Modal
        isOpen={showFilters}
        onRequestClose={() => setShowFilters(false)}
        contentLabel="Filter Modal"
        className="Modal"
        overlayClassName="Overlay"
      >
        <div className='filters-wrapper'>
          <div className='filters'>
          {FILTER_CATEGORIES.map((category) => (
            <div className='filter-group' key={category.key}>
              <label className="filter-category">{category.label}:</label>
              {category.values.map((value) => (
                <label key={value}>
                  <input
                    type="checkbox"
                    value={value}
                    checked={selectedFilters[category.key]?.includes(value)}
                    onChange={(e) => handleFilterChange(category.key, value, e.target.checked)}
                  />
                  {value}
                </label>
              ))}
            </div>
          ))}

            <button onClick={applyFilter} className='filterButton'>Apply Filter</button>
            <button onClick={resetFilters} className='filterButton'>Reset Filters</button>
          </div>
        </div>
      </Modal>
      {!showFilters && <span className="selected-filters">{displaySelectedFilters()}</span>}
    </div>
  );
}  
              
export default FilterPanel;
              
